var React = require('react');

function SmArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.5 12.5h15-15zm15 0-6.75-6.75 6.75 6.75zm0 0-6.75 6.75 6.75-6.75z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M4.5 12.5h15m0 0-6.75-6.75m6.75 6.75-6.75 6.75","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SmArrowRight.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = SmArrowRight;

SmArrowRight.default = SmArrowRight;
